<template>
  <div class="custom-navbar">
    <b-container>
      <b-row class="top-header hide-sm-md">
        <b-col cols="12">
          <b-navbar toggleable="lg" type="dark" class="mt-0">
            <b-collapse
              id="nav-collapse"
              is-nav
              class="d-flex justify-content-start"
            >
              <b-navbar-nav class="menu me-0">
                <b-nav-item :to="{ name: 'Home' }">صفحه اصلی سایت </b-nav-item>
                <b-nav-item :to="{ name: 'NewsList' }"> خبرنامه </b-nav-item>
                <b-nav-item :to="{ name: 'CountactUs' }">تماس با ما</b-nav-item>
                <b-nav-item href="https://www.time.ir/">
                  اوقات شرعی
                </b-nav-item>
                <!-- <b-nav-item :to="{ name: 'Home' }">سوالات متداول </b-nav-item> -->
              </b-navbar-nav>
            </b-collapse>
            <div class="header-time">
              <h2 class="text-p-first p-fs-xl">{{ currentTime }}</h2>
              <h3 class="text-p-first p-fw-semibold mx-3">
                امروز: {{ iranianDate }}
              </h3>
              <!-- <b-button class="login-btn">
                <span class="icon-user-login p-fs-xxxl ms-1"></span>
                ورود / ثبت نام
              </b-button> -->
            </div>
          </b-navbar>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-navbar toggleable="lg" type="dark" class="my-4">
            <b-navbar-brand href="/home" class="me-4 d-flex align-items-center">
              <img src="@/assets/images/logo/03.png" width="42px" />
              <h3 class="p-fw-normal me-3">
                سازمان تبلیغات اسلامی استان مازندران
              </h3>
            </b-navbar-brand>
            <div
              id="navigation-icon"
              v-if="mobileView"
              @click="showNav = !showNav"
            >
              <b-icon icon="list" class="navBar text-p-white"></b-icon>
            </div>
            <div
              class="content"
              id="show-menu"
              v-if="mobileView"
              :class="{ open: !showNav }"
            >
              <div
                id="navigation-icon-close"
                v-if="mobileView"
                @click="colseNav"
              >
                <b-icon icon="x"></b-icon>
              </div>
              <div class="top-bar">
                <TheNavbarMobile />
              </div>
            </div>
            <div id="navigation-mask" v-if="showNav" @click="colseNav"></div>

            <b-collapse
              id="nav-collapse"
              is-nav
              class="d-flex justify-content-between"
            >
              <b-navbar-nav class="menu">
                <b-nav-item :to="{ name: 'Home' }">صفحه نخست </b-nav-item>
                <b-nav-item :to="{ name: 'NewsList' }"
                  >سرویس‌های خبری
                </b-nav-item>

                <!-- <b-nav-item-dropdown text="سرویس‌های خبری" right>
                  <b-dropdown-item :to="{ name: 'NewsList' }" class="text-end">
                    <b-icon
                      icon="circle-fill"
                      scale="0.4"
                      class="text-p-third"
                    ></b-icon>
                    لیست خبرها
                  </b-dropdown-item>

                  <b-dropdown-item
                    :to="{ name: 'NewsDetails' }"
                    class="text-end"
                    ><b-icon
                      icon="circle-fill"
                      scale="0.4"
                      class="text-p-third"
                    ></b-icon>
                    جزئیات خبرها
                  </b-dropdown-item>
                </b-nav-item-dropdown> -->

                <b-nav-item-dropdown text="چندرسانه‌ای" center>
                  <b-dropdown-item
                    :to="{ name: 'MultiMedia' }"
                    class="text-end"
                  >
                    <b-icon
                      icon="circle-fill"
                      scale="0.4"
                      class="text-p-third"
                    ></b-icon>
                    لیست چندرسانه‌ای
                  </b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'Podcast' }" class="text-end">
                    <b-icon
                      icon="circle-fill"
                      scale="0.4"
                      class="text-p-third"
                    ></b-icon>
                    صوت ها
                  </b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'Video' }" class="text-end">
                    <b-icon
                      icon="circle-fill"
                      scale="0.4"
                      class="text-p-third"
                    ></b-icon>
                    ویدیوها
                  </b-dropdown-item>
                  <b-dropdown-item
                    :to="{ name: 'ImageDetails' }"
                    class="text-end"
                  >
                    <b-icon
                      icon="circle-fill"
                      scale="0.4"
                      class="text-p-third"
                    ></b-icon>
                    تصاویر
                  </b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown text="معرفی سازمان" right>
                  <b-dropdown-item
                    class="text-end"
                    v-for="item in items"
                    :key="item.id"
                    :to="{
                      name: 'AboutOrganization',
                      params: { id: item.id },
                    }"
                  >
                    <b-icon
                      icon="circle-fill"
                      scale="0.4"
                      class="text-p-third"
                    ></b-icon>
                    {{ item.title }}
                  </b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item :to="{ name: 'CountactUs' }">
                  تماس با ما
                </b-nav-item>
              </b-navbar-nav>

              <!-- Right aligned nav items -->
              <b-navbar-nav class="hideResponsive">
                <b-input-group>
                  <b-input-group-prepend>
                    <div class="icon-input">
                      <span class="icon-search1 p-fs-huge"></span>
                    </div>
                  </b-input-group-prepend>
                  <div class="header-search">
                    <v-select
                      v-model="searchItem"
                      input-id="searchItem"
                      :options="searchList"
                      item-text="title"
                      item-value="id"
                      :clearable="true"
                      class="p-select search-input"
                      placeholder="جستجو"
                      @search="filter"
                      @input="setSelected"
                    >
                      <template #no-options>
                        <span class="p-select-no-option"> موردی یافت نشد </span>
                      </template>
                    </v-select>
                  </div>
                </b-input-group>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </b-col>
      </b-row>
      <b-row class="align-items-center mt-4 mx-auto hide-desktop">
        <b-col cols="12">
          <div class="position-relative search-select">
            <v-select
              v-model="searchItem"
              input-id="searchItem"
              :options="searchList"
              item-text="title"
              item-value="id"
              :clearable="true"
              class="p-select"
              placeholder="جستجو"
              @search="filter"
              @input="setSelected"
            >
              <template #no-options>
                <span class="p-select-no-option"> موردی یافت نشد </span>
              </template>
            </v-select>
            <b-icon icon="search" class="search-res text-p-first"></b-icon>
          </div>
        </b-col>
        <!-- <b-col cols="3">
          <b-button class="login-btn-res">
            <span class="icon-user-login p-fs-xxxl"></span>
            ورود
          </b-button>
        </b-col> -->
      </b-row>
      <hr class="hr-navbar hide-desktop" />
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment-jalaali";
const now = moment().format("D MMMM YYYY");
import TheNavbarMobile from "@/containers/TheNavbarMobile";

export default {
  name: "TheHeader",

  components: {
    TheNavbarMobile,
  },
  data() {
    return {
      nowDate: now,
      mobileView: true,
      showNav: false,
      currentTime: "",
      searchItem: null,
      date: new Date(),
    };
  },
  computed: {
    ...mapGetters({
      items: "newsX/introductions",
      searchList: "searchOpetions",
    }),
    iranianDate() {
      const persianMoment = moment(this.currentDate).locale("fa");
      const dayOfWeek = persianMoment.format("dddd");
      const dayOfMonth = persianMoment.format("jD");
      const monthName = persianMoment.format("jMMMM");
      const year = persianMoment.format("jYYYY");
      return `${dayOfWeek}- ${dayOfMonth} ${monthName} -${year}`;
    },
    formattedDate() {
      return this.date.toLocaleDateString("ar", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
  },
  watch: {
    $route() {
      this.showNav = false;
    },
  },

  methods: {
    handleView() {
      this.mobileView = window.innerWidth <= 990;
    },
    colseNav() {
      this.showNav = !this.showNav;
    },
    filter(search, loading) {
      loading(true);
      this.$store.dispatch("getSearhcList", search);
      loading(false);
    },
    setSelected() {
      this.$router.push({
        name: "Search",
        params: { key: this.searchItem.label },
      });
    },
    reloadFields() {
      this.searchItem = null;
    },
  },
  created() {
    this.handleView();
  },
  beforeCreate() {
    this.$store.dispatch("newsX/getIntroductions");
  },
  mounted() {
    setInterval(() => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      this.currentTime = `${hours}:${minutes}:${seconds}`;
    }, 1000);
  },
};
</script>
<style lang="sass"></style>
